import React from 'react';
import { Button } from '../button';
import { EventTile } from '../event-tile';
import { Textfield } from '../textfield';

const allowedTypes = [
  'event'
]

export class Search extends React.Component {
  state = {
    events: []
  }

  search = async (e) => {
    e && e.preventDefault();

    const term = this.field.value;
    const results = await window.engine.search(term, allowedTypes, "en");
    const events = results.filter(result => allowedTypes.includes(result.type));

    this.setState({ events });
  }

  render () {
    return (
      <section className="search">
          <form onSubmit={this.search} className="search__form">
            <Textfield focus ref={_ => this.field = _}/>
            <Button onClick={this.search}>Search</Button>
          </form>

          <div className="event-grid__events">
            { this.state.events && this.state.events.map(event => <EventTile {...event} key={event.id} />) }
          </div>
      </section>
    )
  }
}